// extracted by mini-css-extract-plugin
export default {"products":"ProductListing_products__piAwt","filters":"ProductListing_filters__yXrCe"};